<template>
  <div id="app" style="width: 100%; height: 100%;">
    <div id="map" style="width: 100%; height: 100%; position: relative;"></div>
    <div class="information-banner">
      <p style="margin: 0">Средние значения концентрации за последние 24 часа</p>
      <p style="margin: 0">Данные с {{ previousDate }} по {{ currentDate }}</p>
    </div>
    <div
      v-for="(marker, index) in markers"
      :key="'table' + index"
      class="table"
      :style="{ 'border-color': iconColors[marker.icon],
       top: marker.position.top + 'px', left: marker.position.left + 'px' }">
      <div v-html="marker.name"
           style="font-size:14px; font-weight: bold; text-align: center; border-bottom: 1px solid #000;">
      </div>
      <table
        style="display: flex;
          flex-wrap: wrap;
          justify-content: center;">
        <tr v-for="(value, index) in marker.table" :key="index"
          style="width: 100%; display: flex; justify-content: space-evenly;">
          <td style="width: 50%; text-align: center;">{{ value.row }}</td>
          <td style="border-right: 1px solid #000;"></td>
          <td :style="{ 'background': iconColors[getColorFromValue(value.content)],
          'width': '50%', 'text-align': 'center', 'color': 'white' }">{{ value.content }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>

import axios from "axios";
import cryingIcon from "@/assets/crying.png";
import smileIcon from "@/assets/smile.png";
import miniCryingIcon from "@/assets/minicry.png";
import dyingIcon from "@/assets/dying.png";
import sleepingIcon from "@/assets/sleeping.png";

let ymaps = null;

export default {
  name: 'App',
  data: () => ({
    iconColors: {
      [sleepingIcon]: '#969696',
      [smileIcon]: '#42b62d',
      [miniCryingIcon]: '#d5b004',
      [cryingIcon]: '#e10101',
      [dyingIcon]: '#9f040a',
    },
    map: null,
    markers: [],
    currentTime: new Date(),
    mapCenter: [56.03539, 92.86717],
    previousDate: '',
    currentDate: '',
  }),
  methods: {
    updateTime() {
      setInterval(() => {
        this.currentTime = new Date(this.currentTime.getTime() + 20 * 60000);
      }, 20 * 60000);
    },
    getColorFromValue(content) {
      if (content === '-') { return sleepingIcon; }
      if (content >= 0 && content <= 1) { return smileIcon; }
      if (content > 1 && content <= 2) { return miniCryingIcon; }
      if (content > 2 && content <= 3) { return cryingIcon; }
      if (content > 3) { return dyingIcon; }
    },
    loadYandexMapsScript() {
      return new Promise((resolve, reject) => {
        let script = document.createElement('script');
        script.src = "https://api-maps.yandex.ru/2.1/?lang=ru_RU";
        script.async = true;
        script.onload = () => {
          resolve(window.ymaps);
        }
        script.onerror = () => {
          reject(new Error("Failed to load Yandex Maps script"))
        }
        document.head.appendChild(script)
      });
    },
    getMapPlaces() {
      return new Promise((resolve, reject) => {
        axios
          .get('/air/get-map-smiley-markers')
          .then(response => {
            for (let item of response.data) {
              this.markers.push(this.processData(item))
            }
            resolve();
          })
          .catch(err => {
            console.log(err)
            reject(err);
          });
      });
    },
    processData(inputData) {
      let short_name = inputData.name.replace('АПН ', '');
      short_name = short_name.replace('Красноярск-', '');

      let maxData = Math.max(...Object.values(inputData.data));

      let icon;
      if (Object.values(inputData.data).every(value => value === null)) {
        icon = sleepingIcon;
      } else {
        if (maxData >= 0 && maxData <= 1) {
          icon = smileIcon;
        } else if (maxData > 1 && maxData <= 2) {
          icon = miniCryingIcon;
        } else if (maxData > 2 && maxData <= 3) {
          icon = cryingIcon;
        } else if (maxData > 3) {
          icon = dyingIcon;
        }
      }

      return {
        name: short_name,
        icon: icon,
        coords: [inputData.latitude, inputData.longitude],
        data: inputData.data,
        position: {top: 0, left: 0},
      };
    },
    async initMap() {
      await new Promise((resolve) => ymaps.ready(resolve));
      this.map = new ymaps.Map('map', {
        center: this.mapCenter,
        zoom: 12,
        controls: [],
        behaviors: []
      });
    },
    recalculateMarkerPositions() {
      let projection = this.map.options.get('projection');

      this.markers.forEach((marker) => {
        const placemark = new ymaps.Placemark(marker.coords, {}, {
          iconLayout: 'default#image',
          iconImageHref: marker.icon,
          iconImageSize: [70, 70],
          iconImageOffset: [-40, -40],
        });

        this.map.geoObjects.add(placemark);

        const globalPixelCoords = this.map.converter.globalToPage(
            projection.toGlobalPixels(marker.coords, this.map.getZoom())
        );

        marker.position = {
          top: (globalPixelCoords[1]),
          left: (globalPixelCoords[0]),
        };
      });
    },
    createTableData(marker) {

      let tableData = [
        { row: `CO`, content: `-`},
        { row: `SO₂`, content: `-`},
        { row: `NO₂`, content: `-`},
        { row: `PM 2,5`, content: `-`},
        { row: `NH₃`, content: `-`}
      ]

      let mapping = {
        "Азота диоксид": `NO₂`,
        "Аммиак": `NH₃`,
        "Взвешенные частицы (до 2,5 мкм)": `PM 2,5`,
        "Серы диоксид": `SO₂`,
        "Углерода оксид": `CO`
      }

      for (let i = 0; i < tableData.length; i++) {
        let row = tableData[i].row;
        for (let key in marker) {
          if (mapping[key] === row) {
            let value = marker[key];
            if (value === null) {
              tableData[i].content = "-";
              break;
            }
            tableData[i].content = parseFloat(value.toFixed(3));
            break;
          }
        }
      }

      return tableData;
    },
    updateDates() {
      let now = new Date();
      now.setMinutes(Math.floor(now.getMinutes()/20)*20);
      now.setSeconds(0);
      now.setMilliseconds(0);

      this.currentDate = this.formatDate(now);

      let prev = new Date(now.getTime() - (24*60*60*1000)); // Subtract 1 day

      this.previousDate = this.formatDate(prev);
    },
    formatDate(date) {
      let options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
      return new Intl.DateTimeFormat('ru-RU', options).format(date).replace(',', '');
    },
  },
  created() {
    this.updateDates()
  },
  async mounted() {
    await this.getMapPlaces();
    ymaps = await this.loadYandexMapsScript();
    await this.initMap();
    this.recalculateMarkerPositions();
    this.markers.forEach(marker => {
      marker.table = this.createTableData(marker.data);
    });
    this.updateTime()
  }
}
</script>

<style scoped>
.table {
  position: absolute;
  width: 155px;
  border: #dc1ece 3px solid;
  border-radius: 20px;
  background: rgba(255, 255, 255);
  transform: scale(1);
  transition: transform 0.2s ease-in-out;
  z-index: 0;
  overflow: hidden;
}
.table:hover {
  z-index: 1;
  transform: scale(1.15);
}
.information-banner {
  position: absolute;
  top: 200px;
  left: 640px;
  padding: 5px;
  background-color: rgba(255, 255, 255);
  border: #000000 1px solid;
  border-radius: 10px;
  text-align: center;
}
</style>